export const replaceUnderscores = (input: string): string => {
  return input.replace(/_/g, " ");
};

export const replaceUnderscoresUpperCase = (input: string): string => {
  const result = input.replace(/_/g, " ");
  return result.charAt(0).toUpperCase() + result.slice(1);
};
